export function scrollToTargetAdjusted(element){
    let headerOffset = 0;
    const smToLgMediaQuery = window.matchMedia('(max-width: 1023px)');
    const smMediaQuery = window.matchMedia('(max-width: 639px)');

    if (smToLgMediaQuery.matches) {
        headerOffset = 0;
    }

    if (smMediaQuery.matches) {
        headerOffset = 0;
    }

    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.scrollY - headerOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}

// Used for scroll to ctas used generally
window.addEventListener('load', () => {
    let scrollButtons = document.querySelectorAll('button[data-destination]')
    for (let scrollButton of scrollButtons) {
        let destination = scrollButton.dataset.destination;
        let targetElement = document.querySelector(destination);

        if (targetElement) {
            scrollButton.addEventListener('click', () => {
                scrollToTargetAdjusted(targetElement)
            });
        }
    }
});